import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const recruitingApi = {
  // Requisitions
  listRequisitions: (params) => api.get('/recruiting/requisitions', { params }).then(unwrap),
  getRequisition: (id) => api.get(`/recruiting/requisitions/${id}`).then(unwrap),
  createRequisition: (payload) => api.post('/recruiting/requisitions', payload).then(unwrap),
  updateRequisition: (id, patch) => api.patch(`/recruiting/requisitions/${id}`, patch).then(unwrap),
  submitRequisition: (id) => api.put(`/recruiting/requisitions/${id}/submit`).then(unwrap),
  getPipeline: (id) => api.get(`/recruiting/requisitions/${id}/pipeline`).then(unwrap),

  // Candidates
  listCandidates: (params) => api.get('/recruiting/candidates', { params }).then(unwrap),
  getCandidate: (id) => api.get(`/recruiting/candidates/${id}`).then(unwrap),
  createCandidate: (payload) => api.post('/recruiting/candidates', payload).then(unwrap),
  updateCandidate: (id, patch) => api.patch(`/recruiting/candidates/${id}`, patch).then(unwrap),
  linkDocument: (id, documentId) => api.post(`/recruiting/candidates/${id}/documents`, { documentId }).then(unwrap),

  // Applications
  listApplications: (params) => api.get('/recruiting/applications', { params }).then(unwrap),
  getApplication: (id) => api.get(`/recruiting/applications/${id}`).then(unwrap),
  createApplication: (payload) => api.post('/recruiting/applications', payload).then(unwrap),
  moveStage: (id, stage) => api.put(`/recruiting/applications/${id}/stage`, { stage }).then(unwrap),
  rejectApplication: (id, reason) => api.put(`/recruiting/applications/${id}/reject`, { reason }).then(unwrap),
  hire: (id, payload) => api.post(`/recruiting/applications/${id}/hire`, payload).then(unwrap),

  // Interviews
  listInterviews: (params) => api.get('/recruiting/interviews', { params }).then(unwrap),
  createInterview: (payload) => api.post('/recruiting/interviews', payload).then(unwrap),
  updateInterview: (id, patch) => api.patch(`/recruiting/interviews/${id}`, patch).then(unwrap),
  listScorecards: (id) => api.get(`/recruiting/interviews/${id}/scorecards`).then(unwrap),
  addScorecard: (id, payload) => api.post(`/recruiting/interviews/${id}/scorecards`, payload).then(unwrap),

  // Offers
  listOffers: (params) => api.get('/recruiting/offers', { params }).then(unwrap),
  getOffer: (id) => api.get(`/recruiting/offers/${id}`).then(unwrap),
  createOffer: (payload) => api.post('/recruiting/offers', payload).then(unwrap),
  generateOfferPdf: (id) => api.post(`/recruiting/offers/${id}/pdf`).then(unwrap),
  extendOffer: (id, payload) => api.put(`/recruiting/offers/${id}/extend`, payload || {}).then(unwrap),
  acceptOffer: (id) => api.put(`/recruiting/offers/${id}/accept`).then(unwrap),
  declineOffer: (id) => api.put(`/recruiting/offers/${id}/decline`).then(unwrap),
};

export const onboardingApi = {
  listTemplates: (params) => api.get('/onboarding/templates', { params }).then(unwrap),
  getTemplate: (id) => api.get(`/onboarding/templates/${id}`).then(unwrap),
  createTemplate: (payload) => api.post('/onboarding/templates', payload).then(unwrap),
  listJourneys: (params) => api.get('/onboarding/journeys', { params }).then(unwrap),
  getJourney: (id) => api.get(`/onboarding/journeys/${id}`).then(unwrap),
  startJourney: (payload) => api.post('/onboarding/journeys', payload).then(unwrap),
  completeJourney: (id) => api.post(`/onboarding/journeys/${id}/complete`).then(unwrap),
  updateTask: (id, patch) => api.put(`/onboarding/journey-tasks/${id}`, patch).then(unwrap),
};
